import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var PatientListRes;
export const PatientListTodo = createAsyncThunk('PatientList', async (data) => {

    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'admin/patient',
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token')},
            params:{
                "company_id":localStorage.getItem('companyId')
            },
        })
        return PatientListRes = res.data

    } catch (error) {
        return PatientListRes = error.response.data
    }
});

const PatientListSlice = createSlice({
    name: 'PatientList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(PatientListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(PatientListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default PatientListSlice.reducer; 